
	import {
		Component,
		Vue,
		Inject,
		Prop,
		Watch
	} from 'vue-property-decorator';
	import Util from '@/lib/util';
	import wx from 'weixin-js-sdk';
	import AbpBase from '@/lib/abpbase';
	import Viewer from 'v-viewer'
	import 'viewerjs/dist/viewer.css'
	@Component({
		components: {

		}
	})
	export default class NoticeDetail extends AbpBase {
		news: Object = new Object() as any;
		aid: number = 0;
		pageSize: number = 10;
		pageIndex: number = 1;
		userid: number = 0;
		commentBox: boolean = false;
		commentList: Array < Object >= new Array < Object > ();
		commentContent: string = "";
		loadmore: boolean = true;
		imgBox: boolean = false;
		currentImgs: Array < Object >= new Array < Object > ();
		currentImgUrl: string = '';
		optertionInfo: Object = {
			likeId: 0,
			isLike: false,
			followId: 0,
			isFollow: false
		};
		userInfo: Object = new Object();
		anonymous: boolean = false;

		showShare: boolean = false;
		shownews: number = 0; // 0加载中 1 可见 2 不可见
		msg: string = '';
		isPreview: boolean = false;
		screenWidth:number=0;
		
		isEn: boolean = false;
		mycontent:string='';
		domainAccount:string='';

		getNewsByID() {
			var that = this;
			this.$store.dispatch({
				type: 'tag/getAnswerById',
				id: this.aid
			}).then((res) => {
				console.log(res);
				that.news = res as any;
				 that.mycontent=that.isEn?((that.news as any).solutionEn==null||(that.news as any).solutionEn==""?(that.news as any).solution:(that.news as any).solutionEn):(that.news as any).solution;
				 
				
			})
		}
		
		
		changeUrlArg(url, arg, val) {
			var pattern = arg + '=([^&]*)';
			var replaceText = arg + '=' + val;
			return url.match(pattern) ? url.replace(eval('/(' + arg + '=)([^&]*)/gi'), replaceText) :
				(url.match('[\?]') ? url + '&' + replaceText : url + '?' + replaceText);
		}
		
		@Watch('$route')
		routechange(to: any, from: any) {
			if (to.query.aid != from.query.aid) {
				location.reload();
			}
		}

		async created() {
			var that=this;			
			that.screenWidth = document.body.clientWidth
			console.log(that.screenWidth)
			if (this.$route.query.aid && (this.$route.query.aid as any) > 0) {
				this.aid = this.$route.query.aid as any;			
				this.getNewsByID();
			}
			
			var languageName="";
			
			if(abp.localization.currentLanguage.name!='en')
			{
				languageName = 'zh-Hans';
				 that.isEn=false;
			}
			else
			{
				languageName = 'en';				
				that.isEn=true;
			}
			
			


		}
		mounted() {
			var that=this;
			setTimeout(function() {
				var u = navigator.userAgent.toLowerCase();
				if (1==1 || u.indexOf('iphone os 13_4') > -1 || u.indexOf('iphone os 14') > -1 || u.indexOf('ipad') > -1 || u.indexOf('ipod') > -1 || that.screenWidth>=768) {
					let imgs = document.getElementsByClassName('newscot')[0].getElementsByTagName('img');
					for (var i = 0; i < imgs.length; i++) {
						var img = imgs[i] as any;
						img.onclick = function(e) {
							// that.currentImgUrl = e.currentTarget.src;
							// that.currentImgs = [];
							// that.currentImgs.push(that.currentImgUrl);
							// that.imgBox = true;
							// that.$forceUpdate();
							//(window as any).gis.previewImage([e.currentTarget.src]);
							that.currentImgUrl = e.currentTarget.src;
							that.currentImgs = [];
							that.currentImgs.push(that.currentImgUrl);
							//that.imgBox = true;
							const ViewerDom = document.getElementById('viewer');
							((ViewerDom as any).viewer as any).options.title = false;
							((ViewerDom as any).viewer as any).options.navbar = false;
							((ViewerDom as any).viewer as any).options.toolbar=false;
							((ViewerDom as any).viewer as any).images= that.currentImgs;													
							setTimeout(function(){
								var contain=document.getElementsByClassName('descimgBox')[0].getElementsByTagName('img');;
								if(contain!=null && contain.length>0){
									 contain[0].click();
								 }
							},300)
						}
						// img.ontouchend = function(e) {
						// 	(window as any).gis.previewImage([e.currentTarget.src]);
						// }
					}
				
				} else {
					let imgs = document.getElementsByClassName('newscot')[0].getElementsByTagName('img');
					for (var i = 0; i < imgs.length; i++) {
						var img = imgs[i] as any;
						img.onclick = function(e) {
							(window as any).gis.previewImage([e.currentTarget.src]);
						}
					}
				}
			}, 2000)
		}
	};
